import type { Dropdown, NamedInternalLink, RelativeLink } from '../../pages/api/types';
import type { Keyed, KeyedArray } from '../sanity/types';

export interface DropDownMenuProps {
    links: KeyedArray<NamedInternalLink | RelativeLink | Dropdown>;
}

export default function DropDownMenu({ links }: DropDownMenuProps) {
    return (
        <menu>
            {links.map((p) => {
                switch (p._type) {
                    case 'dropdown':
                        return <DropdownLink key={p._key} {...p} />;
                    case 'namedInternalLink':
                        return <NamedInternalLink key={p._key} {...p} />;
                    case 'namedRelativeLink':
                        return <RelativeLink key={p._key} {...p} />;
                }
            })}
        </menu>
    );
}

function NamedInternalLink({ link, name }: NamedInternalLink) {
    return (
        <li>
            <a href={link?.internalReference.path}>{name || link?.internalReference.title}</a>
        </li>
    );
}
function RelativeLink({ name, url }: RelativeLink) {
    return (
        <li>
            <a href={url}>{name}</a>
        </li>
    );
}

function DropdownLink({ links, name, link }: Keyed<Dropdown>) {
    return (
        <li>
            <a href={link.internalReference.path}>{name}</a>
            <DropDownMenu links={links} />
        </li>
    );
}
